/**
 * locale バンドルのレジストリ。LanguageCode から LocaleBundle を引く。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 言語コードと locale bundle のマッピングを集中管理する registry
 * @graph-connects none
 */

import { ja } from './ja.js';
import { en } from './en.js';
import { vi } from './vi.js';
import type { LanguageCode, LocaleBundle } from './types.js';

/** @graph-connects none */
const BUNDLES: Record<LanguageCode, LocaleBundle> = {
  ja,
  en,
  vi,
};

/**
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 指定言語の LocaleBundle を返す。allowlist 外は型エラーで弾かれる
 * @graph-connects none
 */
export function getLocaleBundle(language: LanguageCode): LocaleBundle {
  return BUNDLES[language];
}

export type { LanguageCode, MessagesCatalog, ReadingScript } from './types.js';
export { LANGUAGES } from './types.js';
